const ViewAudio = ({ resource }) => (
  <audio src={resource} controls className='audio-view'>
    <track kind='captions' />
  </audio>
);

export default ViewAudio;
